import { jsx as t } from "@emotion/react/jsx-runtime";
const d = ({
  children: o
}) => /* @__PURE__ */ t("tbody", { children: o });
export {
  d as Body
};
